<h3 mat-dialog-title
    class="title">
    Interview Status
</h3>

<mat-dialog-content class="pr-0 pb-0 dialog-body">
    <form  [formGroup]="permInterview">
        <div class="dialog-body flex-row">
            <div  class="flex-row flex-100">
                <div class="flex-col flex-100">

                    <nova-am-submittal-send-to-client-info-card [model]="viewModel"
                                                                [labelFlex]="labelFlex"
                                                                [dataFlex]="dataFlex">
                    </nova-am-submittal-send-to-client-info-card>

                    <div class="flex-row flex-order-7 block pt-0 no-bottom" *ngIf="!viewModel.isLegacyStatus">
                        <div class="nova__label combobox-label flex-25">Status*</div>
                        <div class="flex-75">
                            <mat-form-field class="no-mat-form-field-padding combobox-field" >
                                <mat-select formControlName="status"
                                            panelClass="combobox-taller-panel"
                                            placeholder="Select a status">
                                    <mat-option *ngFor="let s of subStatuses$ | async"
                                                [value]="s.key">{{s.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="flex-row block pt-0 center-datapicker-line" *ngIf="showInterviewDate">
                        <div class="nova__label flex-25">Interview Date*</div>
                        <mat-form-field>
                            <input matInput placeholder="Select Interview Date" [matDatepicker]="picker" formControlName="interviewDate">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="flex-row block pt-0" >
                        <div class="nova__label flex-25">Live List Note (optional)</div>
                        <div class="flex-75">
                            <div class="note-text-wrapper" [class.error]="noteError">
                                <textarea class="textarea"
                                        matInput
                                        formControlName="liveListNote"
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="4">
                                </textarea>
                            </div>
                            <div class="character-count" [class.error]="noteError">
                                {{noteLength}}/{{maxNoteLength}}
                            </div>
                        </div>
                    </div>

                    <div class="flex-row pt-0">
                        <div class="nova__label flex-25"></div>
                        <div class="flex-75">
                            <div>
                                <button id="update-status"
                                         mat-flat-button
                                        [disabled]="isLoading"
                                        color="primary"
                                        (click)="onSubmit()">
                                        UPDATE STATUS
                                </button>

                                <button mat-flat-button
                                        color="cancel"
                                        (click)="closeDialog()"
                                        [disabled]="isLoading">
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
